<lib-gung-accordion #acc="gungAccordion" class="cart-list">
  @for (cart of data; track cart.id; let i = $index) {
    <lib-gung-accordion-item [id]="cart.id" [customHeader]="true">
      <ng-template libGungAccordionHeader>
        <div class="cart-card-header">
          <div class="cart-meta">
            <div class="cart-title-row">
              <span class="cart-name">{{ cart.name }}</span>
              <span class="cart-date-sep">&middot;</span>
              <span class="cart-date">{{
                dateUtilService.parseDate(cart.creationDate, 'yyyy-MM-dd"T"HH:mm:ss.SSSXXX')
                  | date : dateUtilService.dateFormat
              }}</span>
            </div>
            <div class="cart-sub-row">
              <span class="cart-detail" *ngIf="cart.customerId">
                <span class="cart-detail-label">{{ 'CUSTOMER_ID' | translate }}</span>: {{ cart.customerId }}
              </span>
              <span class="cart-detail" *ngIf="cart.username">
                <span class="cart-detail-label">{{ 'USER_ID' | translate }}</span>: {{ cart.username }}
              </span>
              <span class="cart-detail" *ngIf="cart.data?.rows?.length">
                {{ cart.data.rows.length }} {{ (cart.data.rows.length === 1 ? 'ITEM' : 'ITEMS') | translate }}
              </span>
            </div>
          </div>

          <div class="cart-actions">
            <button
              type="button"
              class="c-btn c-btn-primary"
              (click)="loadCart(cart); $event.preventDefault(); $event.stopPropagation()"
            >
              {{ 'LOAD_CART' | translate }}
            </button>

            <button
              type="button"
              class="c-btn c-btn-ghost"
              (click)="fetchProductData(cart); showSavedCart(cart); $event.preventDefault(); $event.stopPropagation()"
            >
              <i class="fas" [ngClass]="accordion?.isExpanded(cart.id) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              <span>{{ (accordion?.isExpanded(cart.id) ? 'HIDE_DETAILS' : 'SHOW_DETAILS') | translate }}</span>
            </button>

            <button
              type="button"
              class="c-btn c-btn-icon c-btn-danger"
              (click)="deleteCart(cart); $event.preventDefault(); $event.stopPropagation()"
              [attr.aria-label]="'DELETE' | translate"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template libGungAccordionBody>
        <div class="cart-card-body">
          <div class="cart-products" *ngIf="mapData[cart.id]; else loading">
            <table class="cart-table">
              <colgroup>
                <col class="col-id" />
                <col class="col-name" />
                <col class="col-qty" />
                <col class="col-price" />
                <col class="col-icon" />
                <col class="col-icon" />
              </colgroup>
              <thead>
                <tr>
                  <th class="col-id">{{ 'PRODUCT_ID' | translate }}</th>
                  <th class="col-name">{{ 'NAME' | translate }}</th>
                  <th class="col-qty">{{ 'QTY' | translate }}</th>
                  <th class="col-price">{{ 'PRICE' | translate }}</th>
                  <th class="col-icon"></th>
                  <th class="col-icon"></th>
                </tr>
              </thead>
              <tbody cdkDropList (cdkDropListDropped)="drop(i, $event)" class="drag-list">
                <tr *ngFor="let row of mapData[cart.id]" class="draggable-row" cdkDrag>
                  <td class="col-id">
                    <a [routerLink]="['/product/', row.productId]">{{ row.productId }}</a>
                  </td>
                  <td class="col-name">{{ row?.product?.name }}</td>
                  <td class="col-qty">
                    <div class="qty-stepper">
                      <button
                        type="button"
                        class="qty-btn"
                        tabindex="-1"
                        (click)="sub(i, row, cart, inputEle); $event.preventDefault(); $event.stopPropagation()"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                      <input
                        #inputEle
                        type="number"
                        class="qty-input"
                        [(ngModel)]="row.qty"
                        [ngModelOptions]="{ updateOn: 'blur' }"
                        (ngModelChange)="updateQuantity($event, row, cart, inputEle)"
                        (click)="$event.preventDefault(); $event.stopPropagation()"
                        [class.font-weight-bold]="checkModulus(row.qty, row.product?.extra.ar?.artfsgforp).multiple"
                        [step]="row.product?.packageSize || 1"
                      />
                      <button
                        type="button"
                        class="qty-btn"
                        tabindex="-1"
                        (click)="add(i, row, cart, inputEle); $event.preventDefault(); $event.stopPropagation()"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </td>
                  <td class="col-price">
                    <lib-price
                      [price]="row?.product?.extra?.price?.value"
                      [currency]="row?.product?.extra?.price?.currencyCode"
                    ></lib-price>
                  </td>
                  <td class="col-icon">
                    <button type="button" class="row-icon-btn" (click)="deleteRow(i, row, cart)">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                  <td class="col-icon">
                    <i class="fas fa-arrows-alt drag-handle" cdkDragHandle></i>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="cart-body-footer">
              <button type="button" class="c-btn c-btn-ghost" (click)="addProductToCart(cart, i)">
                <i class="fas fa-plus"></i>
                <span>{{ 'ADD' | translate }}</span>
              </button>

              <button
                type="button"
                class="c-btn c-btn-primary"
                *ngIf="saveData[cart.id]"
                (click)="saveCartOrder(i, $event)"
              >
                {{ 'SAVE' | translate }}
              </button>

              <div class="cart-summary">
                <span class="cart-summary-label">{{ 'SUMMARY' | translate }}</span>
                <lib-price [price]="totalPriceByCart[cart.id]" [currency]="currencyCode"></lib-price>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </lib-gung-accordion-item>
  }
</lib-gung-accordion>

<ng-template #loading>
  <div class="cart-loading">
    <i class="fa fa-spinner fa-spin"></i>
    <span>{{ 'LOADING' | translate }}</span>
  </div>
</ng-template>
